<template>
	<vx-tooltip id="printSendCloudLabel" class="vs-con-loading__container" text="Download SendCloud label" v-if="this.sendCloudEnabled && this.order.order.sendcloud">
		<vs-button color="primary" @click.native="downloadSendCloudLabel">
			<font-awesome-icon :icon="['fas', 'file-pdf']" class="fa-icon" />
		</vs-button>
	</vx-tooltip>
</template>

<script>

import downloadClient from '@/services/downloadClient';
import {mapGetters} from 'vuex';

export default {
	props: {
		order: {
			type: Object,
			required: true,
		},
		sendCloudButton: {
			loading: false,
		}
	},
	data() {
		return {
			popupVisible: false,
			totalTransactionFee: 0,
			totalMarge: 0,
			addressPrinter: null,
		}
	},
	computed: {
		...mapGetters({
			sendCloudEnabled: 'dashboard/sendCloudEnabled',
		}),
	},

	methods: {
		downloadSendCloudLabel() {
			this.startLoadingSendCloud();

			downloadClient.downloadSendCloudPdf(this.order.order.sendcloud_parcel_id);

			setTimeout(this.stopLoadingSendCloud, 2000)
		},
		startLoadingSendCloud() {
			this.$vs.loading({
				container: '#printSendCloudLabel',
				scale: 0.45
			})
		},
		stopLoadingSendCloud() {
			this.$vs.loading.close('#printSendCloudLabel > .con-vs-loading')
		}
	}
}
</script>
